import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  VERIFY_RESET_TOKEN_REQUEST,
  VERIFY_RESET_TOKEN_SUCCESS,
  VERIFY_RESET_TOKEN_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  SET_USER,
  CLEAR_USER,
  TOKEN_EXPIRED
} from '../constants/authConstants';

export const loginRequest = () => ({
  type: LOGIN_REQUEST
});

export const loginSuccess = (user, token) => ({
  type: LOGIN_SUCCESS,
  payload: { user, token }
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error
});

export const logoutRequest = () => ({
  type: LOGOUT_REQUEST
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
});

// Reset Password Actions
export const verifyResetTokenRequest = () => ({
  type: VERIFY_RESET_TOKEN_REQUEST
});

export const verifyResetTokenSuccess = (data) => ({
  type: VERIFY_RESET_TOKEN_SUCCESS,
  payload: data
});

export const verifyResetTokenFailure = (error) => ({
  type: VERIFY_RESET_TOKEN_FAILURE,
  payload: error
});

export const resetPasswordRequest = () => ({
  type: RESET_PASSWORD_REQUEST
});

export const resetPasswordSuccess = (message) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: message
});

export const resetPasswordFailure = (error) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error
});

export const setUser = (user) => ({
  type: SET_USER,
  payload: user
});

export const clearUser = () => ({
  type: CLEAR_USER
});

export const tokenExpired = () => ({
  type: TOKEN_EXPIRED
});

// Saga Actions
export const loginUser = (credentials) => ({
  type: 'LOGIN_SAGA',
  payload: credentials
});

export const logoutUser = () => ({
  type: 'LOGOUT_SAGA'
});

export const verifyResetToken = (resetToken, email) => ({
  type: 'VERIFY_RESET_TOKEN_SAGA',
  payload: { resetToken, email }
});

export const resetPassword = (resetToken, email, newPassword) => ({
  type: 'RESET_PASSWORD_SAGA',
  payload: { resetToken, email, newPassword }
});